import * as action from './action.js';
import reducer from './reducer.js';
import ImageCorrectionList from './image_correction_list';

export {action,reducer,ImageCorrectionList};



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/image_correction/index.js